import { ArrowRight, KeyRound, Layers3, MessageSquareText, Sparkles } from 'lucide-react'
import { type FormEvent, useState } from 'react'

import { ApiClientError } from '../api'

interface LoginPageProps {
  onLogin: (actor: string, password: string) => Promise<void>
}

export function LoginPage({ onLogin }: LoginPageProps) {
  const [actor, setActor] = useState('')
  const [password, setPassword] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState('')

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()
    if (!actor.trim() || !password) {
      setError('请填写协作者称呼和访问密码')
      return
    }
    setSubmitting(true)
    setError('')
    try {
      await onLogin(actor.trim(), password)
    } catch (reason) {
      setPassword('')
      setError(reason instanceof ApiClientError ? reason.message : '暂时无法登录，请稍后重试')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <main className="login-page">
      <div className="ambient ambient-one" aria-hidden="true" />
      <div className="ambient ambient-two" aria-hidden="true" />
      <section className="login-story" aria-labelledby="brand-title">
        <div className="brand-mark" aria-hidden="true">
          <span>SHC</span>
        </div>
        <p className="eyebrow">SHARED NOTES · VERSIONED IDEAS</p>
        <h1 id="brand-title">让每一次修改，<br />都有来处。</h1>
        <p className="story-copy">在一张安静的数字书桌上，共同写作、留言讨论，并让 AI 帮你继续推进。</p>
        <ul className="feature-notes" aria-label="工作台能力">
          <li><Layers3 size={18} />文档与历史版本</li>
          <li><MessageSquareText size={18} />有上下文的留言</li>
          <li><Sparkles size={18} />可确认的 AI 修改</li>
        </ul>
      </section>

      <section className="login-paper" aria-labelledby="login-title">
        <div className="paper-pin" aria-hidden="true" />
        <div className="login-icon" aria-hidden="true"><KeyRound size={22} /></div>
        <p className="eyebrow">PRIVATE WORKSPACE</p>
        <h2 id="login-title">进入共享工作台</h2>
        <p className="muted">这里的文档只对持有密码的协作者开放。</p>
        <form onSubmit={submit} noValidate>
          <label htmlFor="actor">协作者称呼</label>
          <input
            id="actor"
            name="actor"
            autoComplete="nickname"
            maxLength={40}
            value={actor}
            onChange={(event) => setActor(event.target.value)}
            placeholder="例如：Shihao"
          />
          <label htmlFor="password">访问密码</label>
          <input
            id="password"
            name="password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            placeholder="输入共享密码"
          />
          {error ? <p className="form-error" role="alert">{error}</p> : null}
          <button className="primary-button login-button" type="submit" disabled={submitting}>
            <span>{submitting ? '正在验证…' : '进入工作台'}</span>
            <ArrowRight size={18} aria-hidden="true" />
          </button>
        </form>
        <p className="privacy-note"><span aria-hidden="true">●</span> 密码通过加密验证，不会保存在浏览器中</p>
      </section>
    </main>
  )
}
